import { Box, Divider, Grid, KpiCard, Typography } from "../../../components";
import { formatPrice } from "../../../utils";

export default function PainelAnaliseFiscalKpis({
  resumoFiscal = {},
  filtros,
  loading,
}) {
  const cards = [
    {
      title: "Faturamento com NF",
      value: formatPrice(resumoFiscal.faturamentoNF),
      icon: "ph-bold ph-receipt",
      color: "#1976d2",
    },
    {
      title: "Notas Autorizadas",
      value: resumoFiscal.notasAutorizadas ?? 0,
      icon: "ph-bold ph-files",
      color: "#2e7d32",
    },
    {
      title: "Notas Rejeitadas",
      value: resumoFiscal.notasRejeitadas ?? 0,
      icon: "ph-bold ph-file-x",
      color: "#d32f2f",
    },
    {
      title: "Notas Inutilizadas",
      value: resumoFiscal.notasInutilizadas ?? 0,
      icon: "ph-bold ph-file",
      color: "#616161",
    },
    {
      title: "Notas em Contingência",
      value: resumoFiscal.notasContingencia ?? 0,
      icon: "ph-bold ph-clock",
      color: "#ffb300",
    },
    {
      title: "Pendentes de Transmissão",
      value: resumoFiscal.notasPendentes ?? 0,
      icon: "ph-bold ph-spinner",
      color: "#ff8f00",
    },
    {
      title: "Sem Documentos Fiscais",
      value: resumoFiscal.semDocumentoFiscal ?? 0,
      icon: "ph-bold ph-warning-circle",
      color: "#fb8c00",
    },
    {
      title: "Notas Canceladas",
      value: resumoFiscal.notasCanceladas ?? 0,
      icon: "ph-bold ph-file-minus",
      color: "#8e24aa",
    },
    {
      title: "NF-e (modelo 55)",
      value: resumoFiscal.qtdNFe ?? 0,
      icon: "ph-bold ph-file",
      color: "#4c6e9b",
    },
    {
      title: "NFC-e (modelo 65)",
      value: resumoFiscal.qtdNFCe ?? 0,
      icon: "ph-bold ph-files",
      color: "#45644a",
    },
  ];

  return (
    <Grid container spacing={2} sx={{ mb: 1 }}>
      <Grid item xs={12}>
        <Box display="flex" alignItems="center" gap={1.5} className="mb-3">
          <Box
            sx={{
              width: 46,
              height: 46,
              borderRadius: 2,
              backgroundColor: "#1976d218",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <i
              className="ph-bold ph-receipt"
              style={{ color: "#1976d2", fontSize: 22 }}
            />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="h5"
              sx={{ fontWeight: 700, lineHeight: 1.1, color: "#1e293b" }}
            >
              Documentos fiscais
            </Typography>
            <Typography
              variant="caption"
              sx={{
                display: "block",
                color: "text.disabled",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              Situação das notas na competência de{" "}
              {new Date(filtros.ate).toLocaleDateString("pt-BR", {
                month: "long",
                year: "numeric",
              })}
            </Typography>
          </Box>
        </Box>
        <Divider sx={{ mb: 1 }} />
      </Grid>
      {cards.map((card) => (
        <Grid key={card.title} item xs={6} md={2.4}>
          <KpiCard
            title={card.title}
            value={card.value}
            icon={card.icon}
            color={card.color}
            loading={loading}
          />
        </Grid>
      ))}
    </Grid>
  );
}
